export default __webpack_public_path__ + "static/media/friends.d6f2f296.png";